import { render, staticRenderFns } from "./Miniapp.vue?vue&type=template&id=ec002718"
import script from "./Miniapp.vue?vue&type=script&lang=ts"
export * from "./Miniapp.vue?vue&type=script&lang=ts"
import style0 from "./Miniapp.vue?vue&type=style&index=0&id=ec002718&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports